var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighPileRug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 4L7 2L8 4L9 2L10 4L11 2L12 4L13 2L14 4L15 2L16 4L17 2L18 4H21V20H3V4H6M6 7V17H18V7H6M1 6H3V9H1V6M21 6H23V9H21V6M1 11H3V14H1V11M21 11H23V14H21V11M1 16H3V19H1V16M21 16H23V19H21V16Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPileRug);
export default __webpack_public_path__ + "static/media/high-pile-rug.89ab8bd39c4d42e4c7c43ec5114a4eb5.svg";
export { ForwardRef as ReactComponent };